import React from 'react';
import EditorStrike from '@wix/da-ds/pkg/Icons/24x24/EditorStrike';
import { isExtensionInstalled } from '../../utils/tiptap';
import { useTranslation } from 'react-i18next';
import EditorIconButton from '../_partials/EditorIconButton';
const Strike = ({ editor, hideWhenNotEnabled = true })=>{
    const { t } = useTranslation('editor');
    if (!editor.isEditable || hideWhenNotEnabled && !isExtensionInstalled(editor, 'strikethrough')) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(EditorIconButton, {
        featureId: "format:strike",
        icon: EditorStrike,
        onClick: ()=>editor.chain().focus().toggleStrike().run(),
        disabled: !editor.can().chain().focus().toggleStrike().run(),
        isActive: editor.isActive('strike'),
        tooltipText: t('button.strike.tooltip'),
        "aria-label": t('button.strike.tooltip')
    });
};
Strike.displayName = 'Strike';
export default Strike;

//# sourceMappingURL=Strike.js.map